import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserMessageModel } from 'src/app/models/Personel';
import { NotifymodalComponent } from 'src/app/notifymodal/notifymodal.component';
import { PersonelService } from 'src/app/services/personel.service';
import { ResetModalComponent } from '../reset-modal/reset-modal.component';

@Component({
  selector: 'app-messagemodal',
  templateUrl: './messagemodal.component.html',
  styleUrls: ['./messagemodal.component.css']
})
export class MessagemodalComponent implements OnInit {

  messageModel = new UserMessageModel();

  public messageForm = new FormGroup({
    caption: new FormControl(''),
    message: new FormControl(''),
  });

  constructor(
    public personelService: PersonelService,
    private dialogRef: MatDialogRef<MessagemodalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog :MatDialog,
  ) { }

  ngOnInit(): void {
  }

  sendMessage() {

    this.messageModel.Message = this.messageForm.value.message;
    this.messageModel.Caption = this.messageForm.value.caption;
    this.messageModel.UserId = this.data.user.Id;

    //console.log(JSON.stringify(this.messageModel));

    this.personelService.createMessage(this.messageModel).subscribe(res => {
      //console.log(res);
      this.dialog.open(NotifymodalComponent, {
        data: {
          isSuccess:true, 
          text:"Mesaj gönderme başarılı.",
          subject:"Mesaj Gönderme"
        }
      });
    },
    error => {
      this.dialog.open(NotifymodalComponent, {
        data: {
          isSuccess:false, 
          text: error.error.error,
          subject:"Mesaj Gönderme"
        }
      });
    });


    this.dialogRef.close();
  }

}
